export const validateGroupName = (name: string) => {
  switch (name) {
    case 'mundoIds':
      return 'mundo'
    case 'mundoSelectIds':
      return 'mundo'
    case 'empresaIds':
      return 'empresa'
    case 'empresaSelectIds':
      return 'empresa'
    case 'tipoCentroIds':
      return 'tipoCentro'
    case 'tipoCentroSelectIds':
      return 'tipoCentro'
    case 'centroCdLojaIds':
      return 'loja'
    case 'centroCdLojaSelectIds':
      return 'loja'
    case 'gerenteProdutoIds':
      return 'gerenteProduto'
    case 'gerenteProdutoSelectIds':
      return 'gerenteProduto'
    case 'categoriaIds':
      return 'categoria'
    case 'categoriaSelectIds':
      return 'categoria'
    case 'categoriaCompactaIds':
      return 'categoriaCompacta'
    case 'categoriaCompactaSelectIds':
      return 'categoriaCompacta'
    case 'statusIds':
      return 'statusEstoque'
    case 'statusSelectIds':
      return 'statusEstoque'
    case 'curvaAbcIds':
      return 'curvaABC'
    case 'curvaAbcSelectIds':
      return 'curvaABC'
    case 'fornecedorIds':
      return 'fornecedor'
    case 'fornecedorSelectIds':
      return 'fornecedor'
    case 'gerenteCategoriaIds':
      return 'gerenteCategoria'
    case 'gerenteCategoriaSelectIds':
      return 'gerenteCategoria'
    case 'depositoIds':
      return 'deposito'
    case 'depositoSelectIds':
      return 'deposito'
    case 'vendaMediaIds':
      return 'periodoVendaMedia'
    case 'CMVouEstoque':
      return 'CMVouEstoque'
    case 'subCategoriaIds':
      return 'subCategoria'
    case 'subCategoriaSelectIds':
      return 'subCategoria'
    default:
      return null
  }
}
